import { render } from "./LanguageSelector.vue?vue&type=template&id=8b357dda&ts=true&lang=pug"
import script from "./LanguageSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./LanguageSelector.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__